import Header from "@/components/header/header";
import ListItemMobile from "@/components/listItemMobile/ListItemMobile";
import PageSwitcher from "@/components/pageSwitcher/PageSwitcher";
import TextButton from "@/components/textButton/TextButton";
import { TopBarMobile } from "@/components/topBarMobile/topBarMobile";
import { translate } from "@/config/translator";
import { formatDateFromLang } from "@/config/utils";
import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow,
} from "@fluentui/react-components";
import { faMessage } from "@fortawesome/pro-light-svg-icons";
import { faMessageExclamation } from "@fortawesome/pro-solid-svg-icons";
import { useMessages } from "./messages/useMessages";
import { ReadMessage } from "@/api/openapi";
import Skeleton from "react-loading-skeleton";

export default function Messages() {
  const {
    columns,
    messages,
    setPage,
    navigate,
    isTablet,
    totalPages,
    page,
    lang,
    searchQuery,
    setSearchQuery,
  } = useMessages();

  if (isTablet)
    return (
      <div className="p-10">
        <Header
          text="messages"
          onChangeSearch={setSearchQuery}
          searchValue={searchQuery}
        />
        {messages?.length === 0 && searchQuery.length === 0 ? (
          <p className="text-font-secondary">
            {translate("noMessagesNotice", lang)}
          </p>
        ) : messages?.length === 0 ? (
          <p className="text-font-secondary">
            {translate("noSearchResultsFound", lang)}
          </p>
        ) : (
          <div className="flex flex-col gap-10">
            <Table className="table-fixed">
              <colgroup>
                {columns.map(({ className }) => (
                  <col className={className} />
                ))}
              </colgroup>
              <TableHeader>
                <TableRow>
                  {columns.map(({ key, label }) => (
                    <TableHeaderCell
                      key={`notifications-table-header-cell-${key}`}
                    >
                      {label}
                    </TableHeaderCell>
                  ))}
                </TableRow>
              </TableHeader>
              <TableBody>
                {(messages ?? Array.from({ length: 20 })).map(
                  (message: ReadMessage | undefined, index) => (
                    <TableRow
                      className={
                        index % 2 === 0 ? "bg-white" : "bg-canvas-secondary"
                      }
                      key={`message-table-row-${message?.id ?? index}`}
                    >
                      <TableCell>{message?.subject ?? <Skeleton />}</TableCell>
                      <TableCell>
                        {message ? (
                          formatDateFromLang(new Date(message.createdAt), lang)
                        ) : (
                          <Skeleton />
                        )}
                      </TableCell>
                      <TableCell>
                        {message?.createdBy.name ?? <Skeleton />}
                      </TableCell>
                      <TableCell>
                        {message ? (
                          translate(
                            message.isRead
                              ? "readPastTense"
                              : "notReadPastTense",
                            lang,
                          )
                        ) : (
                          <Skeleton />
                        )}
                      </TableCell>
                      <TableCell>
                        <TextButton
                          disabled={!message}
                          onClick={() =>
                            message
                              ? navigate(`/messages/read/${message.id}`)
                              : {}
                          }
                        >
                          {translate("read", lang)}
                        </TextButton>
                      </TableCell>
                    </TableRow>
                  ),
                )}
              </TableBody>
            </Table>
            <div className="w-full flex-row flex justify-end">
              <PageSwitcher
                currentPage={page}
                totalPages={totalPages}
                setCurrentPage={setPage}
              />
            </div>
          </div>
        )}
      </div>
    );

  return (
    <>
      <TopBarMobile onBack={() => navigate(-1)} header="messages" />
      <div className="p-6">
        {messages?.length !== 0
          ? (messages ?? Array.from({ length: 20 })).map(
              (message: ReadMessage | undefined, index) => (
                <ListItemMobile
                  key={`message-table-entry-${message?.id ?? index}`}
                  icon={message?.isRead ? faMessage : faMessageExclamation}
                  iconPrimary={!message?.isRead}
                  primaryText={message?.subject}
                  secondaryText={message?.createdAt}
                  onClick={() =>
                    message ? navigate(`/messages/read/${message.id}`) : {}
                  }
                />
              ),
            )
          : messages?.length === 0 && (
              <p className="text-font-secondary">
                {translate("noNotifications", lang)}
              </p>
            )}
      </div>
    </>
  );
}
